/**
 * 其知网 模板管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/index/index' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>模板管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.code" style="width:140px" placeholder="输入code"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.name" style="width:140px" placeholder="输入名称"></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleAdd">添加</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="danger" icon="el-icon-delete">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column align="center" prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column  align="center" prop="code" label="code" width="200">
      </el-table-column>
      <el-table-column  align="center" prop="value" label="value" width="200">
      </el-table-column>
      <el-table-column  align="center" prop="name" label="名称" width="120">
      </el-table-column>
      <el-table-column  align="center" prop="note" label="描述" width="300">
      </el-table-column>
      <el-table-column  align="center" prop="add_time" label="添加时间" width="140">
      </el-table-column>
      <el-table-column  align="center" prop="upd_time" label="修改时间" width="140">
      </el-table-column>
      <el-table-column  align="center" prop="admin_name" label="操作人" width="80">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)" title="预览表格">查看</el-button>
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delExcel(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 添加界面 -->
    <el-dialog :title="title" :visible.sync="addFormVisible" width="50%" @click="closeDialog('addForm')">
      <el-form label-width="120px" :model="addForm" :rules="addFormRules" ref="addForm">
        <el-form-item label="code" prop="code">
          <el-input size="small" v-model="addForm.code" auto-complete="off" placeholder="输入code"></el-input>
        </el-form-item>
        <el-form-item label="上传Excel" prop="value">
                    <el-upload
                      action
                      :http-request="Upload"
                      :before-upload="beforeAvatarVideoUpload"
                      :on-preview="handlePreview"
                      :before-remove="beforeRemove"
                      :on-remove="handleRemove"
                      :on-success="handleSuccess"
                      :on-exceed="handleExceed"
                      drag
                      :limit="limit"
                      :file-list="fileList"
                    >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      将文件拖到此处，或
                      <em>点击上传</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">1.上传过程中请不要关闭弹窗 2.上传文件大小不能超过 10M 3.value在Excel文件上传成功后自动填充</div>
                  </el-upload>
                  <el-progress
                    v-show="showProgress"
                    :text-inside="true"
                    :stroke-width="15"
                    :percentage="progress"
                  ></el-progress>
        </el-form-item>
        <el-form-item label="value" prop="value">
          <el-input size="small" v-model="addForm.value" auto-complete="off" placeholder="输入value" disabled></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input size="small" v-model="addForm.name" auto-complete="off" placeholder="输入名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="note">
          <el-input size="small" v-model="addForm.note" auto-complete="off" placeholder="输入描述"></el-input>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input size="small" v-model="addForm.sort" auto-complete="off" placeholder="排序值"></el-input>
        </el-form-item>
        <el-form-item>
              <el-button size="mini" type="primary" @click="submitAddForm('addForm')">保存</el-button>
              <el-button size="mini" @click='closeDialog("addForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" :rules="editFormRules" ref="editForm">
        <el-form-item label="code" prop="code">
          <el-input size="small" v-model="editForm.code" auto-complete="off" placeholder="输入code" disabled></el-input>
        </el-form-item>
        <el-form-item label="上传Excel" prop="value">
                    <el-upload
                      action
                      :http-request="Upload"
                      :before-upload="beforeAvatarVideoUpload"
                      :on-preview="handlePreview"
                      :before-remove="beforeRemove"
                      :on-remove="handleRemove"
                      :on-success="handleSuccess"
                      :on-exceed="handleExceed"
                      drag
                      :limit="limit"
                      :file-list="fileList"
                    >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      将文件拖到此处，或
                      <em>点击上传</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">1.上传过程中请不要关闭弹窗 2.上传文件大小不能超过 10M 3.value在Excel文件上传成功后自动填充</div>
                  </el-upload>
                  <el-progress
                    v-show="showProgress"
                    :text-inside="true"
                    :stroke-width="15"
                    :percentage="progress"
                  ></el-progress>
        </el-form-item>

        <el-form-item label="value" prop="value">
          <el-input size="small" v-model="editForm.value" auto-complete="off" placeholder="输入value" disabled></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="输入名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="note">
          <el-input size="small" v-model="editForm.note" auto-complete="off" placeholder="输入描述"></el-input>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input size="small" v-model="editForm.sort" auto-complete="off" placeholder="排序值"></el-input>
        </el-form-item>
        <el-form-item>
              <el-button size="mini" type="primary" @click="submitEditForm('editForm')">保存</el-button>
              <el-button size="mini" @click='closeDialog("editForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 模板预览界面 -->
    <el-dialog :title="title" :visible.sync="infoFormVisible" width="50%" @click="closeDialog('infoForm')">
      <iframe v-bind:src="value" width="800px" height="623px" frameborder="0">
        This is an embeded <a target="_blank" href="http://office.com">Microsoft office</a>
        document, powered by <a target="_blank" href="http://office.com/webapps">Office Online</a>
      </iframe>
    </el-dialog>
  </div>
</template>

<script>
import { webMarketExcelList, webMarketAddExcel, webMarketEditExcel, webMarketDelExcel } from '../../api/webMG'
import Pagination from '../../components/Pagination'

//引入ali-oss
import { client, getFileNameUUID } from '@/utils/ali-oss'

//引入富文本 start
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
// import imageResize from 'quill-image-resize-module' // 引用，调整图片大小
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { checkLogin, getCurrentDate } from '../../utils/util'

Quill.register('modules/ImageExtend', ImageExtend)
// Quill.register('modules/imageResize', imageResize)
//引入富文本 end

// const apiUrl = "http://192.168.0.158/index.php";
const apiUrl = "https://zlbb.qzhip.com/index.php";
export default {
  name: "Upload",
  props: {
    limit: {
    type: Number,
    default: 1
    }
    },
  data() {
    return {
       // 视频上传开始
      fileList: [],//文件列
      showProgress: false,//进度条的显示
      dataObj: {}, //存签名信息
      progress: 0, //进度条数据
      // 视频上传结束

      idShow: false,
      loading: false, //是显示加载
      addFormVisible: false, //控制编辑页面显示与隐藏
      editFormVisible: false, //控制编辑页面显示与隐藏
      infoFormVisible: false, //控制预览页面显示与隐藏
      value: '',
      actionType: 0,
      title: '用户详情',
      addTitle: '发布文章',
      addForm: {
          code: '',
          value: '',
          name: '',
          note: '',
          sort: '',
      },
      editForm: {
          id: '',
          code: '',
          value: '',
          name: '',
          note: '',
          sort: '',
      },
       formInline: {
        page: 1,
        ps: 10,
        code: '',
        name: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证
      addFormRules: {
        code: [
          { required: true, message: '请输入code', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '请输入value', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        note: [
          { required: true, message: '请选择描述', trigger: 'blur' }
        ],
      },
      editFormRules: {
        code: [
          { required: true, message: '请输入code', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '请输入value', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        note: [
          { required: true, message: '请选择描述', trigger: 'blur' }
        ],
      },

      videoFlag: false,
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
    }
  },
  // 注册组件
  components: {
    Pagination,
    quillEditor
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      // 视频上传oss 开始

      // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      // 前缀
      let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        let temporary = file.file.name.lastIndexOf(".");
        // let fileNameLength = file.file.name.length;
        // let fileFormat = file.file.name.substring(
        //   temporary + 1,
        //   fileNameLength
        // );
        let fileName = file.file.name;
        // let fileName = getFileNameUUID() + "." + fileFormat;
        // let currentDate = getCurrentDate(); 
        client(that.dataObj)
          .multipartUpload(`qzhip/excel/${fileName}`, file.file, {
            progress: function(p) {
              //p进度条的值
              console.log(p);
              that.showProgress = true;
              that.progress = Math.floor(p * 100);
            }
          })
          .then(result => {
            //上传成功返回值，可针对项目需求写其他逻辑
            //将视频url提取出来并赋值
            console.log(result);
            console.log(videoPrefix+result.name);
            if(that.actionType == 1){
              that.addForm.value = videoPrefix+result.name
            }else if(that.actionType == 2){
              that.editForm.value = videoPrefix+result.name
            }else{
              that.$message({
                  type: 'error',
                  message: '系统错误,请联系开发人员!'
              })
            }
            that.$message({
                type: 'success',
                message: '上传成功'
            })
          })
          .catch(err => {
            console.log("err:", err);
          });
      }
      multipartUpload();
    
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webMarketExcelList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
  
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 显示添加页面
    handleAdd: function(index, row){
      this.title = '添加模板'
      this.actionType = 1,
      this.addForm.code = '',
      this.addForm.value = '',
      this.addForm.name = '',
      this.addForm.note = '',
      this.addForm.sort = '',
      this.addFormVisible = true
    },
    // 提交添加表单
    submitAddForm(addForm){
    //校验参数
      this.$refs[addForm].validate(valid => {
        if(valid){
          console.log(valid)
          console.log(this.addForm)
           webMarketAddExcel(this.addForm)
            .then(res => {
              this.addFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.addFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        }else{
          return false;
        }
      })
    },
    // 显示编辑界面
    handleEdit: function(index, row){
        this.title = '编辑模板'
        this.actionType = 2,
        this.editForm.id = row.id,
        this.editForm.code = row.code,
        this.editForm.value = row.value,
        this.editForm.name = row.name,
        this.editForm.note = row.note,
        this.editForm.sort = row.sort
        this.editFormVisible = true
    },
    // 编辑页面保存方法
    submitEditForm(editForm) {
      //校验参数
      this.$refs[editForm].validate(valid => {
        if(valid){
          console.log(valid)
           webMarketEditExcel(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '更新成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        }else{
          return false;
        }
      })
    },
    // 显示预览页面
    handleInfo: function(index, row){
      console.log(row)
      this.title = '预览模板'
      // this.value = 'https://view.officeapps.live.com/op/embed.aspx?src='+http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/qzhip/excel/测试模板.xlsx'
      this.value = 'https://view.officeapps.live.com/op/embed.aspx?src='+row.value
      // this.value = row.value
      console.log(this.value)
      this.infoFormVisible = true
    },
    // 删除文章
    delExcel(index, row) {
    // 添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
      const delParam = {id:row.id}
      webMarketDelExcel(delParam)
      .then(res=>{
        this.loading = false
        console.log(res);
        res = checkLogin(res)
        if (res.code == 200) {
            this.$message({
                type: 'success',
                message: '删除成功'
          })
            this.getdata(this.formInline)
        } else {
            this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    delAllNew(){
    // 判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
        //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除所有勾选的吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const idStr = JSON.stringify(idsArr)
        const delParam = {ids:idStr}
        webDelAllNews(delParam)
        .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
              this.$message({
                  type: 'success',
                  message: '删除成功'
            })
              this.getdata(this.formInline)
          } else {
              this.$message({
                  type: 'info',
                  message: res.msg
            })
          }
        })
        })
         .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'addForm'){
        this.addFormVisible = false
      }else if(formName == 'editForm'){
        this.editFormVisible = false
      }else{
        this.$message({
            type: 'error',
            message: '系统错误,请联系开发人员!'
        })
      }
      this.$refs[formName].resetFields()
    },
  }
  }
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/Temexcel.vue